import React, { useEffect, useState } from "react";
import axios from "../../../EventDownloader";
import classes from "./Event.module.css";
import MonDetail from "./MonDetail";
import oBonus from "../../../Assets/Data/NestBonus";
import oDrops from "../../../Assets/Data/NestDrops";
import { useTranslation } from 'react-i18next';

const EventDetail = props => {
    const [eventDetails, setEventDetails] = useState([]);
    const [loading1, setLoading1] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [loading3, setLoading3] = useState(true);
    const [bonusTable, setBonusTable] = useState([]);
    const [dropTable, setDropTable] = useState([]);
    // eslint-disable-next-line
    const [t, i18n] = useTranslation(["misc"]);

    useEffect(() => {
        axios.get(props.filename).then(
            resp => {
                setEventDetails(resp.data.Tables);
                setLoading1(false);
            }
        ).catch(error => {
            console.log(error);
        });
        axios.get(props.filename.substr(0, 6) + "d.json").then(
            resp => {
                setDropTable(resp.data.Tables.concat(oDrops.Tables));
                setLoading2(false);
            }
        ).catch(error => {
            console.log(error);
        });
        axios.get(props.filename.substr(0, 6) + "b.json").then(
            resp => {
                setBonusTable(resp.data.Tables.concat(oBonus.Tables));
                setLoading3(false);
            }
        ).catch(error => {
            console.log(error);
        });
    }, [props.filename]);

    return !loading1 && !loading2 && !loading3 ? (
        <>
         <div className={classes.Wrapper}>
            <h2>{t("GENERALINFO")}</h2>
            <p><strong>{t("STARTDATE")}: </strong> {props.headline}</p>
            <p><strong>{t("APPEARANCERATE")}:</strong> {eventDetails[0].EncounterRate * 100 / 16}%</p>
         </div>
         <div className={classes.Wrapper}>
            <h2>{t("GAMESWORD")}</h2>
            <div className={classes.MonWrapper}>
                {
                    eventDetails[0].Entries.reduce((prev, cur) => {
                        if(cur.Exists) {
                            return prev.concat(cur);
                        }
                        return prev;
                    }, []).map((v, idx) => <MonDetail data={v} key={idx} drops={dropTable} bonus={bonusTable} />)
                }
            </div>
         </div>
         <div className={classes.Wrapper}>
            <h2>{t("GAMESHIELD")}</h2>
            <div className={classes.MonWrapper}>
            {
                    eventDetails[1].Entries.reduce((prev, cur) => {
                        if(cur.Exists) {
                            return prev.concat(cur);
                        }
                        return prev;
                    }, []).map((v, idx) => <MonDetail data={v} key={idx} drops={dropTable} bonus={bonusTable} />)
                }
            </div>
         </div>
        </>
        ) : null;
};

export default EventDetail;